var React = require('react');

function ArrowL (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"25.5","cy":"25.5","r":"25.5","fill":"#2E3BA7","key":0}),React.createElement("g",{"clipPath":"url(#clip0)","key":1},React.createElement("path",{"d":"M18.3 25.3L27.3 16.3C27.7 15.9 28.3 15.9 28.7 16.3C29.1 16.7 29.1 17.3 28.7 17.7L20.4 26L28.7 34.3C29.1 34.7 29.1 35.3 28.7 35.7C28.3 36.1 27.7 36.1 27.3 35.7L18.3 26.7C17.9 26.3 17.9 25.7 18.3 25.3Z","fill":"white"})),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"11","height":"20","fill":"white","transform":"translate(29 36) rotate(-180)"})))]);
}

ArrowL.defaultProps = {"width":"51","height":"51","viewBox":"0 0 51 51","fill":"none"};

module.exports = ArrowL;

ArrowL.default = ArrowL;
